import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { contentApiTypes } from './types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

const TOAST_ID = 'content-add-materials-bulk';

export const addContentMaterialsBulk = ({
  items,
  managerId,
}: contentApiTypes.AddMaterialsBulkParams) => {
  return axios.post('/content/materials/bulk', {
    items,
    ...(managerId && { managerId }),
  }) as Promise<contentApiTypes.AddMaterialsBulkResponse>;
};

type AddContentMaterialsBulkOptions = {
  config?: MutationConfig<typeof addContentMaterialsBulk>;
};

export const useAddContentMaterialsBulk = ({
  config = {},
}: AddContentMaterialsBulkOptions = {}) => {
  const { onSuccess, onMutate, onError, ...restConfig } = config;

  return useMutation({
    ...restConfig,
    mutationFn: addContentMaterialsBulk,
    onMutate: (variables) => {
      toasts.loadingToast.loading(TOAST_ID, 'Сохранение...');
      return onMutate?.(variables);
    },
    onSuccess: (data, variables, context) => {
      toasts.loadingToast.success(TOAST_ID, 'Материалы сохранены');
      const pageId = variables.items[0]?.pageId;
      if (pageId) {
        queryClient.invalidateQueries(['content-materials', pageId]);
      }
      onSuccess?.(data, variables, context);
    },
    onError: (error: AxiosError<{ error: string }>, variables, context) => {
      toasts.loadingToast.error(TOAST_ID, error.response?.data?.error);
      onError?.(error, variables, context);
    },
  });
};
